export const REFETCH_LOCATIONS_AT_INTERVAL = true
export const REFETCH_LOCATIONS_INTERVAL = 1800000
